// extracted by mini-css-extract-plugin
module.exports = {"ant-tabs-top":"Tables_ant-tabs-top__2xCHn","ant-tabs-nav":"Tables_ant-tabs-nav__6O8nB","ant-tabs-ink-bar":"Tables_ant-tabs-ink-bar__2B8hu"};